import { useOnboardingStore } from '../onboarding/onboardingStore.js';
import { msg } from '../../lib/messages.js';

// Injected by Vite at build time; falls back to 'dev'.
const BUILD = import.meta.env.VITE_BUILD_HASH ?? 'dev';

/** OM section (spec 07): version, setup guide, disclaimer, attribution. */
export function AboutSection(): JSX.Element {
  const openDisclaimer = useOnboardingStore((s) => s.openDisclaimer);
  const openSetup = useOnboardingStore((s) => s.maybeShowSetup);

  return (
    <section className="settings__section">
      <h2 className="settings__section-title">{msg.settings.aboutSection}</h2>

      <div className="settings-row">
        <span className="settings-row__label">{msg.settings.version}</span>
        <span className="account__value numeral">{BUILD}</span>
      </div>

      <button type="button" className="about__link" onClick={() => openSetup(true)}>
        {msg.settings.setupGuide}
      </button>
      <button type="button" className="about__link" onClick={openDisclaimer}>
        {msg.settings.disclaimerLink}
      </button>

      <p className="about__attribution">© Kartverket · {msg.disclaimer.body}</p>
    </section>
  );
}
